import { logger } from '~/utils/logger'

export const state = () => ({
  descriptions: []
})

export const mutations = {
  setDescriptions(state, data) {
    state.descriptions = data
  }
}

export const getters = {
  getDescriptions: state => {
    return state.descriptions
  }
}

export const actions = {
  async get_descriptions({ commit }, payload) {
    const engine = await payload.engine

    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['Key']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Description']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Pop-up Bubble']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Title']
            }
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let descriptionResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      const data = {
        key: values[m][0].qText,
        description: values[m][1].qText,
        popupBubble: values[m][2] ? values[m][2].qText : '',
        title: values[m][3].qText
      }
      descriptionResults.push(data)
    }
    logger.debug('descriptionResults: ', descriptionResults)
    commit('setDescriptions', descriptionResults)
  }
}
